export default "__VITE_ASSET__Dk2OmDun__"